import { render } from "./Paginator.vue?vue&type=template&id=c45978b6&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

import "./Paginator.vue?vue&type=style&index=0&id=c45978b6&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45978b6"]])

export default __exports__